import {
  Grid,
  Typography,
  Box,
  Button,
  CircularProgress,
  Select,
  TextField,
  MenuItem,
  Chip,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import { AppEntryRepository } from "../repositories/AppEntryRepository";
import PageLayout from "../common/PageLayout";
import { IoListOutline } from "react-icons/io5";
import { FaRegClock } from "react-icons/fa6";
import { FaLock } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { BsFiles } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import EntryTable from "./EntryTable";
import { TbFilterOff, TbSearch } from "react-icons/tb";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/mk";
import { Transliteration } from "../common/Transliteration";
import { themeConfig } from "../../config/ThemeConfig";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { Enumerations } from "../../config/Enumerations";

const filterLabels = {
  trackingNumber: "Идентификатор",
  applicantName: "Подносител",
  dateSubmitted: "Датум на поднесување",
  status: "Статус",
};

export default function InProgressEntries() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useState({
    status: "DONE",
  });
  const auth = useSelector((state) => state.auth);
  const [orderBy, setOrderBy] = useState("id");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [statuses, setStatuses] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    getAllStatuses();
    getAll(0, 10);
  }, []);

  const getAll = (page, size) => {
    setLoading(true);
    setData();
    AppEntryRepository.getAll(page, size, searchParams, orderBy, orderDirection)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
      });
  };

  const handleChangePage = (event, newPage) => {
    getAll(newPage, data?.size);
  };

  const handleChangeRowsPerPage = (event) => {
    getAll(0, parseInt(event.target.value, 10));
  };

  const handleChange = (name, value) => {
    let tmp = { ...searchParams };
    tmp[name] = value;
    setSearchParams(tmp);
  };

  const getAllStatuses = () => {
    AppEntryRepository.getAllStatuses()
      .then((res) => {
        setStatuses(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDeleteAppliedFilter = (key) => {
    const updatedAppliedFilters = { ...appliedFilters };
    delete updatedAppliedFilters[key];
    setAppliedFilters(updatedAppliedFilters);

    const updatedSearchParams = { ...searchParams };
    delete updatedSearchParams[key];
    setSearchParams(updatedSearchParams);
    getAll(0, 10);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setAppliedFilters({ ...searchParams });
      getAll(0, 10, searchParams, orderBy, orderDirection);
    } else if (event.key === "Escape") {
      setSearchParams({});
      setAppliedFilters({});
      getAll(0, 10, {}, orderBy, orderDirection);
    }
  };

  return (
    <PageLayout title="Завршени барања" Icon={BsFiles} prev={location.pathname}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <TextField
            size="small"
            placeholder="Идентификатор"
            autoComplete="off"
            inputProps={{ spellCheck: "false" }}
            onChange={(e) => {
              handleChange("trackingNumber", e.target.value.toUpperCase());
            }}
            value={searchParams?.trackingNumber || ""}
            className="login-textfield"
            onKeyDown={handleKeyDown}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            size="small"
            placeholder="Подносител"
            autoComplete="off"
            inputProps={{ spellCheck: "false" }}
            onChange={(e) =>
              handleChange(
                "applicantName",
                Transliteration.toUpperCyrilic(e.target.value)
              )
            }
            value={searchParams?.applicantName || ""}
            className="login-textfield"
            onKeyDown={handleKeyDown}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["day"]}
              label={"Датум на поднесување"}
              value={
                searchParams?.dateSubmitted
                  ? dayjs(searchParams.dateSubmitted, "DD/MM/YYYY")
                  : null
              }
              onChange={(newValue) => {
                handleChange(
                  "dateSubmitted",
                  newValue ? newValue.format("DD/MM/YYYY") : null
                );
              }}
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText={null}
                  size="small"
                  sx={{
                    marginTop: "5px",
                  }}
                  value={
                    params.inputProps.value
                      ? dayjs(params.inputProps.value).format("DD/MM/YYYY")
                      : ""
                  }
                  fullWidth
                />
              )}
              orientation="landscape"
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={1.5}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            sx={{ padding: "0 10px", height: 38, marginTop: "5px" }}
            onClick={() => {
              setAppliedFilters({ ...searchParams });
              getAll(0, 10, searchParams, orderBy, orderDirection);
            }}
            startIcon={<TbSearch />}
          >
            {!loading ? (
              <Typography className="login-button-text">Пребарај</Typography>
            ) : (
              <CircularProgress size={20} id="circular-progress" />
            )}
          </Button>
        </Grid>
        <Grid item xs={12} md={1.5}>
          <Button
            fullWidth
            variant="transparent"
            sx={{
              padding: "0 10px",
              height: 38,
              marginTop: "5px",
              border: "1px solid #d0d0d0",
            }}
            startIcon={<TbFilterOff style={{ color: "#ef233c" }} />}
            onClick={() => {
              setSearchParams({});
              setAppliedFilters({});
              getAll(0, 10, {}, orderBy, orderDirection);
            }}
          >
            {!loading ? (
              <Typography
                variant="caption"
                sx={{
                  fontSize: "14px",
                  fontFamily: "Inter-Regular",
                  marginLeft: "2px",
                  color: themeConfig.palette.secondary.main,
                }}
              >
                Исчисти
              </Typography>
            ) : (
              <CircularProgress size={20} id="circular-progress" />
            )}
          </Button>
        </Grid>

        <Grid item xs={12} style={{ gap: "5px", display: "flex" }}>
          {Object.entries(appliedFilters)
            .filter(
              ([key, value]) =>
                value !== null && value !== "" && value !== undefined
            )
            .map(([key, value]) => {
              const displayValue =
                key === "status"
                  ? Enumerations.AppEntryStatus[value] || value
                  : value;

              return (
                <Chip
                  key={key}
                  label={`${filterLabels[key] || key}: ${displayValue}`}
                  variant="outlined"
                  onDelete={() => handleDeleteAppliedFilter(key)}
                />
              );
            })}
        </Grid>
        <Grid item xs={12} style={{ marginTop: "10px" }}>
          <EntryTable
            data={data}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            loading={loading}
          />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
